export default {
    SET_TOKEN(state, payload) {
        if (payload != null)
            localStorage.setItem('identity', JSON.stringify(payload));
        state.token = payload;
    },
}